import React from 'react';
import { FadeIn } from './FadeIn';
export function Mechanism() {
  return <section className="py-24 bg-cream relative overflow-hidden" data-id="element-78">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-79">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-terracotta/5 rounded-full blur-3xl" data-id="element-80"></div>
        <div className="absolute bottom-0 -left-24 w-80 h-80 bg-sage/10 rounded-full blur-3xl" data-id="element-81"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-82">
        <FadeIn data-id="element-83">
          <div className="text-center mb-12" data-id="element-84">
            <span className="text-terracotta font-medium tracking-wider uppercase text-sm mb-4 block" data-id="element-85">
              La Solución
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-brown mb-6" data-id="element-86">
              El Espejo de Crecimiento
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-87">
          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl shadow-brown/5 border border-cream-dark text-center" data-id="element-88">
            <p className="text-xl md:text-2xl text-brown leading-relaxed mb-8 font-serif italic" data-id="element-89">
              Un sistema diseñado para madres latinas que sincroniza el hito
              biológico del niño con tu respuesta emocional.
            </p>
            <div className="w-24 h-px bg-terracotta/30 mx-auto mb-8" data-id="element-90"></div>
            <p className="text-lg text-brown-light leading-relaxed" data-id="element-91">
              No es un manual de obediencia; es un traductor de crisis que te
              enseña a leer qué necesidad hay detrás de cada grito,
              permitiéndote ser el ancla en su tormenta en lugar de ser parte de
              ella.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}